// Legal pages of the portal (they apply to the forum too). Labels and paths are the portal's own.

export const footerLegal = [{
  label: 'Политика конфиденциальности',
  path: '/politika-konfidencialnosti/'
}, {
  label: 'Политика безопасности',
  path: '/politika-bezopasnosti/'
}, {
  label: 'Cookie',
  path: '/cookie/'
}, {
  label: 'Пользовательское соглашение',
  path: '/usloviya-ispolzovaniya/'
}, {
  label: 'Отказ от ответственности',
  path: '/otkaz-ot-otvetstvennosti/'
}];